export default __webpack_public_path__ + "static/media/milena_m.b35863db.jpg";